
export class Notification {
  public notificationID: number;
  public title: string;
  public notificationType: string;
  public notificationDetail: string;
 // public roleID: number;
  public eventID: number;
  //public startDate: string;
  //public endDate: string;
  public isActive: boolean;
  public sortOrder: number;
  public createdDate: Date;
  public customRoleNames: string;
  public image: string;
  public icon: string;
  public totalRecords: number;
  public isImage: boolean;
  public isIcon: boolean;

}
export class TrigerNotification {
  public notificationTrigerID: number;
  public notificationID: number;
  public title: string;
  public actionUrl: string;
  public notificationType: string;
  public notificationDetail: string;
  public isRead: boolean;
  public createdDate: Date;
  public roleId: number;
  public userId: number;
  public userName: string;
  public image: string;
  public icon: string;
  public totalRecords: number;
  public isImage: boolean;
  public isIcon: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/notification/notification.model.ts